import { Box, Button } from "@mui/material";



function IconButton(props) {

    return (
        <Button
            onClick={props.onClick}
            sx={{
                position: "relative",
                width: "48px",
                height: "48px",
                color: "#383A3A",
                fontDamily: "Rowdies",
                borderRadius: "100px",
                minWidth: "20px",
                border: props.border2 ? "3px solid #00000061" : "1px solid white",
                backgroundColor: { xs: "white", sm: props.active ? "white" : "#FFFFFF33" },
                textTransform: "capitalize",
                transitionProperty: "background-color, box-shadow,transform,filter",
                transitionDuration: " 0.5s",
                '&:hover': {
                    backgroundColor: "white",
                    transform: "scale(1.1)",

                },
                '&:hover img': {
                    transitionProperty: "filter",
                    transitionDuration: " 0.5s",
                    filter: props.active ? "invert(0)" : "invert(1)"
                },
                '& img': {
                    transitionProperty: "background-color, box-shadow,transform,filter",
                    transitionDuration: " 0.5s",
                    filter: { xs: props.active ? "invert(0)": "invert(1)", sm: "invert(0)" }
                },
                "&::before":
                    props.border && {
                        content: '" "',
                        position: "absolute",
                        top: "-4px",
                        zIndex: "-1",
                        backgroundColor: " #ffffff75",
                        width: " 100%",
                        height: "100%",
                        borderRadius: "100px",
                        padding: "4px",

                    }

            }}
        >
            <Box
                sx={{
                    width: "20px",
                    filter: { xs: "invert(1)", sm: "invert(0)" },
                    '&:hover': {
                        filter: { xs: "invert(1)", sm: "invert(0)" }

                    },
                }}
                component="img"
                src={props.component}
            />
        </Button >
    )

}

export default IconButton